import { render, staticRenderFns } from "./UBO.vue?vue&type=template&id=2782eb3e&scoped=true&"
import script from "./UBO.vue?vue&type=script&lang=ts&"
export * from "./UBO.vue?vue&type=script&lang=ts&"
import style0 from "./UBO.vue?vue&type=style&index=0&id=2782eb3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2782eb3e",
  null
  
)

export default component.exports